import React, { useState, ReactElement, useMemo, useEffect } from 'react';
import { ModalBackground, ModalWrapper } from './Modal.styled';
import { ComponentProps as Props, GroupComponent } from './Modal.types';
import Header from './Header/Header';
import Content from './Content/Content';
import Footer from './Footer/Footer';
import CloseBtn from './CloseBtn/CloseBtn';

export const Modal: React.FC<Props> & GroupComponent = ({
  showCloseBtn = true,
  children,
  isOpen,
  onClose,
  onOpen,
  ...props
}): ReactElement<Props> => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';

    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen]);

  return (
    isOpen && (
      <ModalBackground style={{ backgroundColor: 'rgba(45, 53, 64, 0.6)' }}>
        <ModalWrapper {...props}>
          {showCloseBtn && <CloseBtn onClick={onClose} />}
          {children}
        </ModalWrapper>
      </ModalBackground>
    )
  );
};

Modal.Header = Header;
Modal.Content = Content;
Modal.Footer = Footer;

export default Modal;
